import React from "react";
import Layout from "../components/organisms/Layout";
import WrapperLegal from "../components/atoms/WrapperLegal";

const privacyPolicy = () => {
  return (
    <Layout>
      <WrapperLegal
        title={"Políticas de Privacidad"}
        content={Politicas_Content}
        para={PARA}
      />
    </Layout>
  );
};

const PARA = (
  <p>
    SACAMO TECNOLOGIES SAPI DE CV, BAJATUSEGURO.COM, AGENTE DE SEGUROS, S.A. DE
    C.V. Y BTS SERVICIO INTERNACIONAL, S.A. DE C.V., conocidos comercialmente
    como bajatuseguro.com con domicilio en C.P. 11550, Ciudad de México, CDMX y
    portal de internet{" "}
    <a href="https://bajatuseguro.com">www.bajatuseguro.com</a> es responsable
    de recabar sus datos personales, del uso que se le dé a los mismos y de su
    protección. Y al respecto le informamos lo siguiente:
  </p>
);

const Politicas_Content = (
  <main>
    <h2>¿Para qué fines utilizaremos sus datos personales?</h2>
    <div>
      <ul>
        Los datos personales que recabamos de usted, los utilizaremos para las
        siguientes finalidades que son necesarias para el servicio que solicita
        (Finalidades primarias):
        <li>
          La identificación del titular para el cumplimiento de las obligaciones
          contenidas en nuestro contrato de prestación de servicios que tenemos
          suscrito.
        </li>
        <li>
          Para realizar las gestiones como intermediario en la contratación del
          seguro que es de su interés.
        </li>
        <li>
          Proveerle de las cotizaciones y servicios como intermediario y de los
          productos que ha solicitado o contratado.
        </li>
        <li>
          Para la evaluación de su solicitud de seguro y selección de riesgos,
          trámite de sus solicitudes de pago de siniestros, administración,
          mantenimiento y renovación de la póliza de seguro, prevención de
          fraude y operaciones ilícitas.
        </li>
      </ul>
      <ul>
        De manera adicional, utilizaremos su información personal para las
        siguientes finalidades secundarias que no son necesarias para el
        servicio solicitado, pero que nos permiten y facilitan brindarle una
        mejor atención:
        <li>
          Notificarle sobre nuevos servicios o productos que tengan relación con
          los ya contratados o adquiridos.
        </li>
        <li>
          Comunicarle sobre cambios en los mismos; elaborar estudios y programas
          que son necesarios para determinar hábitos de consumo. realizar
          evaluaciones periódicas de nuestros productos y servicios a efecto de
          mejorar la calidad de los mismos.
        </li>
        <li>Mercadotecnia o Publicidad. </li>
        <li>Prospección Comercial.</li>
      </ul>
      <p>
        En caso de que no desee que sus datos personales se utilicen para estos
        fines secundarios, indíquelo a continuación, o envíenos un correo
        electrónico a{" "}
        <a href="mailto:contacto@bajatuseguro.com">contacto@bajatuseguro.com</a>
      </p>
      <ul>
        No consiento que mis datos personales se utilicen para los siguientes
        fines:
        <li>
          Notificarle sobre nuevos servicios o productos que tengan relación con
          los ya contratados o adquiridos.
        </li>
        <li>
          Comunicarle sobre cambios en los mismos; elaborar estudios y programas
          que son necesarios para determinar hábitos de consumo.
        </li>
        <li>
          Realizar evaluaciones periódicas de nuestros productos y servicios a
          efecto de mejorar la calidad de los mismos.
        </li>
        <li>Mercadotecnia o Publicidad. </li>
        <li>Prospección Comercial.</li>
        <li>
          La negativa para el uso de sus datos personales para estas finalidades
          no podrá ser un motivo para que le neguemos los servicios y productos
          que solicita o contrata con nosotros.
        </li>
      </ul>
    </div>
    <h2>¿Qué datos personales utilizaremos para estos fines?</h2>
    <div>
      <ul>
        Para llevar a cabo las finalidades descritas en el presente aviso de
        privacidad, utilizaremos los siguientes datos personales:
        <li>Datos de identificación</li>
        <li>Datos de contacto</li>
        <li>Datos sobre características físicas.</li>
      </ul>
      <ul>
        Además de los datos personales mencionados anteriormente, para las
        finalidades informadas en el presente aviso de privacidad utilizaremos
        los siguientes datos personales considerados como sensibles, que
        requieren de especial protección y de su consentimiento
        <li>Estado de salud físico presente, pasado o futuro. </li>
        <li>Datos patrimoniales y/o financieros.</li>
      </ul>
    </div>
    <h2>¿Con quién compartimos su información personal y para qué fines?</h2>
    <div>
      <ul>
        La información personal del Titular no podrá ser objeto de enajenación a
        terceras personas. Sin embargo, se autoriza a compartirla en los
        siguientes casos:
        <li>
          Cuando dicha transferencia de información se efectué con terceros para
          dar cumplimiento a los servicios o gestiones u obligaciones pactadas
          con el Titular.
        </li>
        <li>
          En los casos que lo exija la Ley, o la procuración o administración de
          justicia.{" "}
        </li>
        <li>
          Cuando el titular de dicha información otorgue su consentimiento de
          manera expresa.
        </li>
      </ul>
      <p>
        Le informamos que sus datos personales son compartidos dentro del país
        con las compañías del sector asegurador, particularmente con
        Aseguradoras, Instituciones Financieras, y Las empresas de Servicio que
        operan para la plataforma de Bajatuseguro.com para la cotización previa
        a la contratación del seguro conforme a su solicitud.
      </p>
    </div>
    <h2>
      ¿Cómo puede acceder, rectificar o cancelar sus datos personales, u
      oponerse a su uso?
    </h2>
    <div>
      <p>
        Usted tiene derecho a conocer qué datos personales tenemos de usted,
        para qué los utilizamos y las condiciones del uso que les damos
        (Acceso). Asimismo, es su derecho solicitar la corrección de su
        información personal en caso de que esté desactualizada, sea inexacta o
        incompleta (Rectificación); que la eliminemos de nuestros registros o
        bases de datos cuando considere que la misma no está siendo utilizada
        adecuadamente (Cancelación); así como oponerse al uso de sus datos
        personales para fines específicos (Oposición). Estos derechos se conocen
        como derechos ARCO.
      </p>
      <p>
        Mecanismos para el ejercicio de derechos ARCO y revocación de
        consentimiento.
      </p>
      <p>
        Los mecanismos que se han implementado para el ejercicio de dichos
        derechos en los términos que marca la Ley, requieren que usted dirija su
        solicitud a nuestro Departamento de Protección de Datos Personales,
        ubicado en C.P. 11550, Ciudad de México, CDMX o bien, se comunique al
        teléfono 01(55) 800-439-2252 o vía correo electrónico a:{" "}
        <a href="mailto:contacto@bajatuseguro.com">contacto@bajatuseguro.com</a>
        , el cual solicitamos confirme vía telefónica para garantizar su
        correcta recepción y respuesta en términos de Ley, siguiendo el
        siguiente procedimiento:
        <ul>
          Ingresar solicitud por escrito en el domicilio indicado o enviar como
          se ha dicho la solicitud por correo electrónico. Dicha solicitud debe
          contener y acompañarse de lo siguiente:
          <li>
            Nombre del titular de los datos y domicilio, correo electrónico u
            otro medio para comunicarle la respuesta a su solicitud.{" "}
          </li>
          <li>
            Documentos que acrediten su identidad o Identificación oficial o
            documento con el que se acredite la representación del Titular.{" "}
          </li>
          <li>
            Descripción clara y precisa de la información respecto de la cual se
            solicite el acceso, rectificación, oposición o cancelación, según
            sea el caso.{" "}
          </li>
          <li>
            En caso de solicitudes de rectificación, acompañar la documentación
            que sustente su petición.
          </li>
          <li>
            Cualquier otro elemento o documento que facilite la localización de
            los datos personales.
          </li>
        </ul>
        <ul>
          <li>
            A dicha información, el personal responsable del Departamento de
            Protección de Datos Personales, encargado de cumplimiento de las
            políticas de protección de datos, dará respuesta en un plazo máximo
            de 20 días y de resultar procedente conforme a la Ley aplicable, se
            hará efectiva dentro de los 15 días siguientes a la fecha en que se
            comunique la respuesta.{" "}
          </li>
          <li>
            Tratándose de solicitudes de acceso procederá la entrega mediante
            cualquier medio físico o electrónico, previa acreditación de la
            identidad del solicitante o representante legal, según corresponda,
            con los documentos originales para su cotejo.{" "}
          </li>
          <li>
            La entrega de los datos será gratuita, debiendo el titular cubrir
            únicamente los gastos justificados de envío o el costo de
            reproducción de copias u otros formatos.
          </li>
        </ul>
      </p>
      <p>
        Asimismo, mediante el mismo mecanismo o procedimiento, en todo momento
        usted podrá revocar el consentimiento que nos ha otorgado para el
        tratamiento de sus datos personales, o bien usted como titular puede
        limitar el uso que conforme al presente aviso se dé a su información
        personal u oponerse al tratamiento para fines secundarios.
      </p>
      <p>
        Sin embargo, es importante que tenga en cuenta que no en todos los casos
        podremos atender su solicitud o concluir el uso de forma inmediata, ya
        que es posible que por alguna obligación legal requiramos seguir
        tratando sus datos personales. Asimismo, usted deberá considerar que
        para ciertos fines, la revocación de su consentimiento implicará que no
        le podamos seguir prestando el servicio que nos solicitó, o la
        conclusión de su relación con nosotros.
      </p>
      <p>
        En caso de que no desee de recibir mensajes promocionales de nuestra
        parte, puede enviarnos su solicitud por medio de la dirección
        electrónica:{" "}
        <a href="mailto:contacto@bajatuseguro.com">contacto@bajatuseguro.com</a>
        . Si usted desea usar el formulario de solicitud que ponemos a su
        disposición para facilitar el ejercicio de derechos ARCO, puede
        solicitarlo en la siguiente dirección electrónica:{" "}
        <a href="mailto:contacto@bajatuseguro.com">contacto@bajatuseguro.com</a>
      </p>
      <ul>
        Los datos de contacto de la persona o departamento de datos personales,
        que está a cargo de dar trámite a las solicitudes de derechos ARCO son
        los siguientes, y con quien podrá dirigirse para mayor información del
        procedimiento de revocación:
        <li>
          Nombre de la persona o departamento de datos personales: Departamento
          de protección de datos a cargo de Jose Escarcega Castañeda{" "}
        </li>
        <li>
          Domicilio: C.P. 11550, Ciudad de México, CDMX.{" "}
        </li>
        <li>Correo electrónico: contacto@bajatuseguro.com </li>
        <li>Teléfono: 800 HEYBAJA (439-2252)</li>
      </ul>
    </div>
    <h2>
      ¿Cómo puede limitar el uso o divulgación de su información personal?
    </h2>
    <div>
      <p>
        Con objeto de que usted pueda limitar el uso y divulgación de su
        información personal, le ofrecemos los siguientes medios: vía correo
        electrónico:{" "}
        <a href="mailto:contacto@bajatuseguro.com">contacto@bajatuseguro.com</a>
      </p>
      <p>El uso de tecnologías de rastreo en nuestro portal de internet.</p>
      <p>
        Le informamos que en nuestra página de internet{" "}
        <a href="https://bajatuseguro.com">www.bajatuseguro.com</a> utilizamos
        cookies, web beacons u otras tecnologías, a través de las cuales es
        posible monitorear su comportamiento como usuario de internet, así como
        brindarle un mejor servicio y experiencia al navegar en nuestra página.
      </p>
      <p>
        La cookie es un archivo de datos que se almacena en el disco duro del
        equipo de cómputo o del dispositivo de comunicaciones electrónicas de un
        usuario al navegar en un sitio de internet específico, el cual permite
        intercambiar de estado entre dicho sitio y el navegador del usuario. La
        información del estado puede revelar medios de identificación de sesión,
        autenticación o preferencias del usuario, así como cualquier dato
        almacenado por el navegador respecto al sitio de internet. La próxima
        vez que ingrese a nuestro portal, podremos usar la información
        almacenada en la cookie para facilitarte el uso de nuestro sitio de
        Internet. La mayoría de las cookies expiran después de un periodo
        determinado de tiempo, o bien las puede borrar en el momento en que lo
        desee, siguiendo las instrucciones de su navegador de Internet.
        Asimismo, puede hacer que su navegador le avise cuando reciba una cookie
        de manera que pueda aceptarla o rechazarla siguiendo las instrucciones
        de su navegador de Internet.
      </p>
      <ul>
        Los datos personales que recabamos a través de estas tecnologías, los
        utilizaremos para los siguientes fines:
        <li>
          Gestiones como intermediario en la contratación del seguro que es de
          su interés.{" "}
        </li>
        <li>Identificación del titular. </li>
        <li>Proveerle de las cotizaciones y servicios como intermediario.</li>
      </ul>
      <ul>
        Los datos personales que obtenemos de estas tecnologías de rastreo son
        los siguientes:
        <li>Datos de identificación, nombre de usuario. </li>
        <li>Idioma preferido por el usuario. </li>
        <li>Región en la que se encuentra el usuario. </li>
        <li>Tipo de navegador del usuario. </li>
        <li>Tipo de sistema operativo del usuario. </li>
        <li>Fecha y hora del inicio y final de una sesión de un usuario. </li>
        <li>Páginas web visitadas por un usuario. </li>
        <li>Búsquedas realizadas por un usuario. </li>
        <li>Publicidad revisada por un usuario. </li>
        <li>Listas y hábitos de consumo en páginas de compras. </li>
        <li>Datos de contacto. </li>
        <li>Datos patrimoniales y financieros. </li>
        <li>Estado de salud físico presente o pasado.</li>
      </ul>
    </div>
    <h2>¿Cómo puede conocer los cambios en este aviso de privacidad?</h2>
    <div>
      <p>
        El presente aviso de privacidad puede sufrir modificaciones, cambios o
        actualizaciones derivadas de nuevos requerimientos legales; de nuestras
        propias necesidades por los productos o servicios que ofrecemos; de
        nuestras prácticas de privacidad; de cambios en nuestro modelo de
        negocio, o por otras causas. Nos comprometemos a mantenerlo informado
        sobre los cambios que pueda sufrir el presente aviso de privacidad, a
        través de: página web:{" "}
        <a href="https://bajatuseguro.com/aviso-privacidad.html">
          www.bajatuseguro.com/aviso-privacidad
        </a>
      </p>
      <p>
        El procedimiento a través del cual se llevarán a cabo las notificaciones
        sobre cambios o actualizaciones al presente aviso de privacidad es el
        siguiente: página web:{" "}
        <a href="https://bajatuseguro.com/aviso-privacidad.html">
          www.bajatuseguro.com/aviso-privacidad
        </a>
      </p>
      <p>Su consentimiento para el tratamiento de sus datos personales</p>
      <p>
        Si este aviso de privacidad no se te da a conocer de manera directa o
        personal, tienes un plazo de 5 días hábiles para oponerte al tratamiento
        y transferencia de tus datos para los fines secundarios indicados,
        utilizando los mismos medios mencionados anteriormente en este aviso.
      </p>
      <p>
        Se entenderá que el Titular consiente tácitamente el tratamiento de su
        información personal en los términos indicados en el presente Aviso de
        Privacidad si no manifiesta su oposición al mismo en los términos
        indicados con anterioridad. Para mayor información al respecto usted
        puede enviar un correo electrónico a:{" "}
        <a href="mailto:contacto@bajatuseguro.com">contacto@bajatuseguro.com</a>
      </p>
    </div>
  </main>
);

export default privacyPolicy;
